import React from "react";
import { getReportlist, exportReportPDF } from "../Actions/ReportsAPI";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import Moment from "moment";
import ReportCard from "./ReportCard";
import { Multiselect } from "multiselect-react-dropdown";
import { getShipnameList } from "../Actions/HelpersAPI";
import { DownloadDocument } from "../Actions/CommonAPI";
import Autocomplete from "react-autocomplete";

const constSearchData = {
   
  vesselname: "",
  minyear: "",
  maxyear: "",
  pagesize: 10,
  pagenumber: 1,
};

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: "",
      SelectedToDate: "",
      ships: [],
      ShipList: [],
      searchDate: {
        vesselname: "",
        minyear: "",
        maxyear: "",
        pagesize: 10,
        pagenumber: 1,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchReportData = this.SearchReportData.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
  }

 async componentDidMount() {
    this.props.dispatch({ type: "SubBannerTitle", data: "Reports" });
    await this.props.dispatch(getShipnameList());
    await this.props.dispatch(getReportlist(this.state.searchDate));
  }

  handleInputChange(e,field) {
    let nodeName = e.target.name;
    this.state.searchDate[nodeName] = e.target.value;
    this.setState({});
  }
  handleInputShipChange(e,field){
    this.state.searchDate[field] = e.target.value; 
    this.setState({});    
  }
  SearchReportData(pgno) {
    this.state.searchDate["pagenumber"] = pgno;
    const { dispatch } = this.props;
    dispatch(getReportlist(this.state.searchDate));
  }
  handleFromDateChange(date) {
    this.state.searchDate.minyear = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }
  handleToDateChange(date) {
    this.state.searchDate.maxyear = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }
  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }
  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }
  renderMovieTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }
  ClearSearchField() {
    let param = { ...constSearchData };
    this.setState(
      {
        searchDate: param,
        SelectedFromDate: "",
        SelectedToDate: "",
      },
      () => {
        this.props.dispatch(getReportlist(this.state.searchDate));
      }
    );
  }
  ExportReport() {
    const { dispatch } = this.props;
    dispatch(exportReportPDF(this.state.searchDate));
  }
  handleSelectChange(value, field,) { 
    const { dispatch } = this.props;
    this.state.searchDate[field] = value;
   this.setState({});
  }

  onSelectChange(item) {
    this.state.ships = item;
    this.state.searchDate["vesselname"] = item.toString();
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.ships = item;
    this.state.searchDate["vesselname"] = item.toString();
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  render() {
    const { ReportList, ShipNameList, ReportCountList } = this.props;
    return (
      <div className="full-height w-100">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-4"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        <div className="grey-bg  course-list-page">
          <div className="px-4 pt-3">
            <div
              className="card MM-card-header mb-0"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1E3A8A",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-2 mt-2"
                  style={{ color: "092a51" }}
                >
                  Reports
                </h5>
              </div>
            </div>
            <div className="panel-box search-filter-box mb-4">
              <div className="row" style={{ paddingBottom: "12px" }}>
                {/* <div className="col-lg-4">
                                    <label className="form-label" >Ship Name</label><br></br>
                                    <input className="form-control" type="text" name="vesselname" onChange={(e) => this.handleInputChange(e)} value={this.state.searchDate.vesselname} ></input>
                                </div> */}
                {/* <div className="col-lg-4">
                                    <label className="form-label" >Ship Name</label><br></br>
                                    <Multiselect options={ShipNameList} isObject={false}
                                        style={{ option: { "margin-right": 0, "display": "block", "font-weight": "normal" }, chips: { "background-color": "#1E3A8A" } }}
                                        onSelect={(item) => this.onSelectChange(item)}
                                        onRemove={(item) => this.onRemoveChange(item)}
                                        //selectedValues={this.state.ships}
                                        placeholder={this.state.ships && this.state.ships.length ? "" : "Select"}
                                        closeIcon="cancel"
                                    />
                                </div> */}
                <div className="col-xl-4">
                  <label className="form-label">Ship Name</label>
                  <br></br>
                  <div className="autocomplete-wrappers mb-3 prd-3 pl-1  prm-3 " >
                  <Autocomplete
                    value={this.state.searchDate.vesselname}
                    items={ShipNameList}
                    getItemValue={(item) => item}
                    renderInput={(props) => {
                      return (
                        <input
                          className="form-control"
                          id="exampleFormControlInput23"
                          placeholder="Ship Name"
                          {...props}
                          style={{ border: "1px solid #ced4da" }}
                        />
                      );
                    }}
                    shouldItemRender={this.renderMovieTitle.bind(this)}
                    renderMenu={(item) => (
                      <div className="dropdowns">{item}</div>
                    )}
                    renderItem={(item, isHighlighted) => (
                      <div
                        className={`items ${
                          isHighlighted ? "selected-items" : ""
                        }`}
                      >
                        {item}
                      </div>
                    )}
                    onChange={(e, field) =>
                      this.handleInputShipChange(e, "vesselname")
                    }
                    onSelect={(value) =>
                      this.handleSelectChange(value, "vesselname")
                    }
                  />
                  </div>
                
                </div>

                <div className="col-lg-4">
                  <label className="form-label">From Date</label>
                  <br></br>
                  <div
                    className="input-group add-on date datepicker"
                    data-date-format="yyyy-mm-dd"
                  >
                    <input
                      type="text"
                      value={this.state.searchDate.minyear}
                      className="form-control date-picker"
                      placeholder="From Date"
                      name="fromDate"
                    ></input>
                    <DatePicker
                      selected={this.state.SelectedFromDate}
                      onChange={this.handleFromDateChange}
                      open={this.state.fromDatePickerIsOpen}
                      onClickOutside={this.handleBlur}
                      popperPlacement="top-end"
                      closeOnScroll={true}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      startDate={this.state.SelectedFromDate}
                      maxDate={this.state.SelectedToDate}
                      className="form-control date-picker w-5 hide-date"
                    />
                    <div
                      className="input-group-btn calendar-icon"
                      onClick={this.openFromDatePicker}
                    >
                      <button className="btn btn-default">
                        <i className="fa fa-calendar mt-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">To Date</label>
                  <br></br>
                  <div
                    className="input-group add-on date datepicker"
                    data-date-format="yyyy-mm-dd"
                  >
                    <input
                      value={this.state.searchDate.maxyear}
                      type="text"
                      placeholder="To Date"
                      className="form-control date-picker"
                      name="toDate"
                      data-date-format="yyyy-mm-dd"
                    />
                    <DatePicker
                      selected={this.state.SelectedToDate}
                      onChange={this.handleToDateChange}
                      open={this.state.toDatePickerIsOpen}
                      onClickOutside={this.handleBlur}
                      className="form-control date-picker w-5 hide-date"
                      closeOnScroll={true}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      popperPlacement="top-end"
                      endDate={this.state.SelectedToDate}
                      minDate={this.state.SelectedFromDate}
                    />
                    <div className="input-group-btn calendar-icon">
                      <button
                        className="btn btn-default"
                        onClick={this.openToDatePicker}
                      >
                        <i className="fa fa-calendar mt-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <label className="form-label"></label>
                  <br></br>
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-info text-uppercase txtside-btn txtht-btn blue"
                      type="button"
                      onClick={() => this.ExportReport()}
                    >
                      {" "}
                      Export PDF
                    </button>

                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                      type="submit"
                      onClick={() => this.SearchReportData(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.ClearSearchField()}
                    >
                      {" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {ReportList  ?(
              <ReportCard
                ReportList={ReportList}
                pageSize={this.state.searchDate.pagesize}
                setUpdatedState={(value) => this.SearchReportData(value)}
                downloadAttachment={(FileName, Guid) =>
                  this.downloadAttachment(FileName, Guid)
                }
                ReportCountList={ReportCountList}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  downloadAttachment = (FileName, Guid) => {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(FileName, Guid));
  };
}
function mapStateToProps(state) {
  return {
    ReportList: state.SidePanReducer.ReportList,
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    ReportCountList:state.SidePanReducer. ReportCountList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Report);
